import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader } from 'lucide-react';

interface AdminRouteProps {
  children: React.ReactElement;
}

/**
 * AdminRoute komponent
 * Beskytter routes som kun skal være tilgjengelige for admin-brukere.
 * Redirecter ikke-admins til dashboard.
 */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <Loader size={48} className="animate-spin text-blue-600" />
          <p className="text-gray-600">Laster...</p>
        </div>
      </div>
    );
  }

  return isAdmin() ? children : <Navigate to="/dashboard" replace />;
};

export default AdminRoute;

